module.exports = __webpack_public_path__ + "static/scale-model-of-american-legacy-tours-in-cincinnati-ohio-08657dffc24cf91ffeb2cf8424139300.png";